<template>
  <NavTabs
    customClass="capitalize_title"
    :tabs="tabs"
    :activeTab="newActiveTab"
    :containerCustomStyle="'padding: 0px; max-width: initial;'"
    @sendData="updateData"
  />
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import analysisGroup from '@/views/billing/infos/analysisGroup';
import simpleAnalysis from '@/views/billing/infos/simpleAnalysis';
import details from '@/views/billing/infos/details';

export default {
    components: {
        NavTabs,
    },
    props: {
        billingInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [details, analysisGroup, simpleAnalysis],
            data: {
                nodeInfo: null,
            },
            model: {},
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    async created() {
        this.loading = true;
        this.$store.dispatch('changeActiveTab', 0);
        const analysisRequests = await this.getBillingAnalysisRequest(this.billingInfo.id);
        this.billingInfo.analysisRequests = analysisRequests;

        this.model.items = this.transformAnalysisTypes(this.billingInfo.analysisRequests.analysisTypes);
        this.model.analysisGroup = this.billingInfo.analysisRequests.selectedAnalysisGroups.map(
            group => ({
                ...group,
                name: group.name[this.userLang],
                analysisTypes: this.transformAnalysisTypes(group.analysisTypes),
            }),
        );
        this.model.billingInfo = this.billingInfo;
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    methods: {
        transformAnalysisTypes(analysisTypes) {
            return analysisTypes.map(an => ({
                ...an,
                analysisName: an.name && an.name[this.userLang] ? an.name[this.userLang] : '',
            }));
        },
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { ...this.model },
                name: this.$t(`billing.labels.info.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(value) {
            this.$emit('sendData', value);
        },
        async getBillingAnalysisRequest(labWorkOrderId) {
            const { data } = await this.$rq.getBillingAnalysisRequest(labWorkOrderId);
            return data;
        },
    },
};
</script>
